'use strict';

angular.module('openDataApp')
  .controller('KvkCtrl', ['$scope', '$http', 'ApiService', function ($scope, $http, ApiService) {
    // Showcase logic
    var lastTry;
    $scope.available = true;
    $scope.submitShowcase = function(nr) {
      if (nr === undefined) {
        $scope.nrStatus = 'Vul een KVK-nummer in';
      } else if (nr !== lastTry) {
        lastTry = nr;
        ApiService.getCompany(nr)
          .then(
            function success(response) {
              if (response.data.status === 0) {
                $scope.hasResult = true;
                $scope.nrStatus = '';
                $scope.result = {
                  name: response.data.name,
                  street:  response.data.street + ' ' +  response.data.number + (response.data.numberaddition!==null?response.data.numberaddition:""),
                  postal:  response.data.postal,
                  city:  response.data.city,
                  sbi: response.data.sbi
                };
              } else if (response.data.status === 404) {
                $scope.hasResult = false;
                $scope.kvk = {};
                $scope.nrStatus = "Dit KVK-nummer is niet gevonden.";
              } else if (response.data.status === 90) {
                $scope.hasResult = false;
                $scope.nrStatus = 'Je hebt het maximaal aantal gratis resultaten bereikt. Neem een betaald abonnement voor meer resultaten.';
                $scope.available = false;
              }
            },
            function error() {
              $scope.kvk = {};
              $scope.nrStatus = "Er is iets misgegaan, probeer het later nog eens";
            }
          );
      }
    };
  }]);
